import { ApiInstance } from '@src/services/api-instance';
import { BrainV1Service } from './modules/v1/brain-api-v1';

export class BrainApi {
  private readonly client: ApiInstance;

  public v1: BrainV1Service;

  constructor(client?: ApiInstance) {
    this.client = client || new ApiInstance(`${import.meta.env.VITE_BRAIN_BASE_URL}`, 30000);

    this.v1 = new BrainV1Service(this.client);
  }
}
